// Auto-generated normalizer for table: CAR_BOOKING.EmpleadoTurno
export function empleadoTurnoNormalize(row) {
  return {
    idEmpleadoTurno: row.idEmpleadoTurno ?? row.IdEmpleadoTurno ?? row['idEmpleadoTurno'] ?? 0,
    idEmpleado: row.idEmpleado ?? row.IdEmpleado ?? row['idEmpleado'] ?? 0,
    idTurno: row.idTurno ?? row.IdTurno ?? row['idTurno'] ?? 0,
    activo: row.activo ?? row.Activo ?? row['activo'] ?? false,
  };
}